import React, { Component } from 'react'
import {
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering
} from '@devexpress/dx-react-grid'
import {
  Grid,
  Table,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow
} from '@devexpress/dx-react-grid-bootstrap4'
import {
  Card,
  Col,
  Row
} from 'react-bootstrap'

function llenarArray (camsCalados) {
  const filasgrilla = []
  camsCalados.filas.map(control => (
    filasgrilla.push({
      fechaDeCalado: `${new Date(control.fechaDeCalado).toLocaleString('es-AR')}`,
      cartaDePorteAutomotor: control.cartaDePorteAutomotor,
      camion: control.camion,
      cereal: control.cereal,
      cerealVariedad: control.cerealVariedad,
      exportador: `${control.exportador}`,
      titularDeCupo: `${control.titularDeCupo} }`,
      remitenteComercial: `${(control.remitenteComercial) ? control.remitenteComercial : ''}`,
      corredorComprador: `${control.corredorComprador} `,
      calificacionCereal: control.calificacionCereal,
      humedad: control.humedad,
      puestoDeCalado: control.puestoDeCalado,
      estadoAutorizacion: control.estadoAutorizacion,
      peritoCalador: control.peritoCalador,
      calleDeCalado: control.calleDeCalado
    })
  )
  )
  return filasgrilla
}

class CamionesCalados extends Component {
  constructor (props) {
    super(props)
    this.columns = []
    this.rows = []
    this.defaultColumnWidths = []
    this.sorting = [{ columnName: 'fechaDeAlta', direction: 'asc' }]
    this.columnWidths = [
      { columnName: 'fechaDeCalado', width: 100 },
      { columnName: 'cartaDePorteAutomotor', width: 100 },
      { columnName: 'camion', width: 100 },
      { columnName: 'cereal', width: 100 },
      { columnName: 'cerealVariedad', width: 100 },
      { columnName: 'exportador', width: 300 },
      { columnName: 'remitenteComercial', width: 120 },
      { columnName: 'corredorComprador', width: 220 },
      { columnName: 'calificacionCereal', width: 100 },
      { columnName: 'humedad', width: 100 },
      { columnName: 'puestoDeCalado', width: 100 },
      { columnName: 'calleDeCalado', width: 100 },
      { columnName: 'estadoAutorizacion', width: 100 },
      { columnName: 'peritoCalador', width: 100 }
    ]
    this.filas = []
  }

  componentDidMount () {
    // Llamar a la funcion que trae los datos del BE
    this.props.obtenerDatosCamionesCalados()
    this.columns = [
      { name: 'fechaDeCalado', title: 'Fecha' },
      { name: 'cartaDePorteAutomotor', title: 'C. Porte' },
      { name: 'camion', title: 'Patente' },
      { name: 'cereal', title: 'Cereal' },
      { name: 'cerealVariedad', title: 'Variedad' },
      { name: 'exportador', title: 'Exportador' },
      { name: 'remitenteComercial', title: 'Rte.Comercial' },
      { name: 'corredorComprador', title: 'Corredor de cupo' },
      { name: 'calificacionCereal', title: 'Calificación' },
      { name: 'humedad', title: 'Humedad' },
      { name: 'puestoDeCalado', title: 'Puesto' },
      { name: 'calleDeCalado', title: 'Calle' },
      { name: 'estadoAutorizacion', title: 'Autorización' },
      { name: 'peritoCalador', title: 'Perito' }
    ]
  }

  componentWillUpdate () {
  }

  componentWillUnmount () {
    this.props.resetCamionesCalados()
  }

  render () {
    const {
      camsCalados,
      camsCaladosFiltro,
      camsCaladosAnchoColumna,
      camsCaladosSorting,
      onFiltersChange,
      onChangeColumnWidths,
      onChangeSorting
    } = this.props

    if (camsCalados !== null && camsCalados.filas_procesadas > 0) {
      this.filas = llenarArray(camsCalados)
    }

    return (
      <div >
        <h1 >
              Reporte de Calado
        </h1>
        <br />
        <div className='grilla-container'>
          <Row>
            <Col xs={12} md={12}>
              <br />
              <Card>
                <Card.Header style={{ backgroundColor: 'rgb(119, 181, 249)', color: 'white' }}>
                  <Card.Title> Listado de Camiones Calados</Card.Title>
                </Card.Header>
                <Card.Body>

                  <Grid rows={this.filas} columns={this.columns} >
                    <FilteringState
                      filters={camsCaladosFiltro}
                      onFiltersChange={onFiltersChange}
                    />
                    <IntegratedFiltering />
                    <SortingState
                      defaultSorting={this.sorting}
                      sorting={camsCaladosSorting}
                      onSortingChange={onChangeSorting}
                    />
                    <IntegratedSorting />
                    <Table />
                    <TableColumnResizing
                      defaultColumnWidths={this.columnWidths}
                      columnWidths={camsCaladosAnchoColumna}
                      onColumnWidthsChange={onChangeColumnWidths}
                    />
                    <TableHeaderRow
                      showSortingControls
                    />
                    <TableFilterRow />
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}
export default CamionesCalados
